import apiService from '#services/api';
import debug from '#services/debug.service';
import {
  CreateRegionRequest,
  ListedRegionResponse,
  PaginationRequestDto,
  PaginationResponseDto,
  RegionResponse,
  UpdateRegionRequest,
} from 'types';

export class RegionsService {
  private readonly API_ROUTES = {
    regions: 'admin/regions/',
    region: (regionId: string) => `admin/regions/${regionId}`,
  };

  public async getRegion(regionId: string) {
    try {
      const request = await apiService.request.get(
        this.API_ROUTES.region(regionId),
      );

      const result: RegionResponse = await request.json();

      debug.success('🧑🏻‍💻 ~ RegionsService ~ getRegion ~ result:', result);

      return result;
    } catch (err) {
      debug.error('🧑🏻‍💻 ~ RegionsService ~ getRegion ~ err:', err);

      throw err;
    }
  }

  public async createRegion(data: CreateRegionRequest) {
    try {
      const request = await apiService.request.post(this.API_ROUTES.regions, {
        headers: {
          'content-type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      const result: RegionResponse = await request.json();

      debug.success('🧑🏻‍💻 ~ RegionsService ~ createRegion ~ result:', result);

      return result;
    } catch (err) {
      debug.error('🧑🏻‍💻 ~ RegionsService ~ createRegion ~ err:', err);

      throw err;
    }
  }

  public async getRegions(filters: PaginationRequestDto) {
    try {
      const request = await apiService.request.get(this.API_ROUTES.regions, {
        headers: {
          'content-type': 'application/json',
        },
        searchParams: filters,
      });

      const result: PaginationResponseDto<ListedRegionResponse> =
        await request.json();

      debug.success('🧑🏻‍💻 ~ RegionsService ~ getRegions ~ result:', result);

      return result;
    } catch (err) {
      debug.error('🧑🏻‍💻 ~ RegionsService ~ getRegions ~ err:', err);

      throw err;
    }
  }

  public async updateRegion(regionId: string, data: UpdateRegionRequest) {
    try {
      const request = await apiService.request.patch(
        this.API_ROUTES.region(regionId),
        {
          headers: {
            'content-type': 'application/json',
          },
          body: JSON.stringify(data),
        },
      );

      const result: RegionResponse = await request.json();

      debug.success('🧑🏻‍💻 ~ RegionsService ~ updateRegion ~ result:', result);

      return result;
    } catch (err) {
      debug.error('🧑🏻‍💻 ~ RegionsService ~ updateRegion ~ err:', err);

      throw err;
    }
  }

  public async deleteRegion(regionId: string) {
    try {
      const request = await apiService.request.delete(
        this.API_ROUTES.region(regionId),
      );

      const result: RegionResponse = await request.json();

      debug.success('🧑🏻‍💻 ~ RegionsService ~ deleteRegion ~ result:', result);

      return result;
    } catch (err) {
      debug.error('🧑🏻‍💻 ~ RegionsService ~ deleteRegion ~ err:', err);

      throw err;
    }
  }
}
